import gql from 'graphql-tag';

export const queryForCompanies = gql`
  query queryForCompanies(
    $limit: Int
    $page: Int
    $query: CompanySortOrQuery
    $sort: CompanySortOrQuery
  ) {
    queryForCompanies(limit: $limit, page: $page, query: $query, sort: $sort) {
      items {
        id
        name
        abbreviation
        enabled
        version
      }
      totalRecords
    }
  }
`;
